$(function () {
  square('.download ');

  $(window).on('resize',function () {
    square('.download ');
  })
})
